import { getItemSourceY } from "./domAnchors.js";

const CARD_GAP = 18;

export function getViewportFocusSource(viewport) {
  const readingHeight = Math.max(0, viewport.innerHeight - viewport.topbarHeight);
  return viewport.scrollY + viewport.topbarHeight + readingHeight / 2;
}

export function computeDesktopCardPositions({
  items,
  listRectTop,
  viewport,
  measurementsById,
}) {
  const entries = items
    .map(function (item) {
      const measurement = measurementsById.get(item.id);
      if (!measurement) {
        return null;
      }

      const anchorRect = item.anchor.getBoundingClientRect();
      return {
        item,
        height: measurement.height,
        sourceY: getItemSourceY(item),
        desiredTop: anchorRect.top - listRectTop,
      };
    })
    .filter(Boolean)
    .sort(function (left, right) {
      return left.sourceY - right.sourceY;
    });

  if (!entries.length) {
    return {};
  }

  const focusSource = getViewportFocusSource(viewport);
  let focusIndex = 0;
  let focusDistance = Infinity;

  entries.forEach(function (entry, index) {
    const distance = Math.abs(entry.sourceY - focusSource);
    if (distance < focusDistance) {
      focusDistance = distance;
      focusIndex = index;
    }
  });

  const positions = new Array(entries.length);
  positions[focusIndex] = entries[focusIndex].desiredTop;

  for (let index = focusIndex - 1; index >= 0; index -= 1) {
    positions[index] = Math.min(
      entries[index].desiredTop,
      positions[index + 1] - entries[index].height - CARD_GAP
    );
  }

  for (let index = focusIndex + 1; index < entries.length; index += 1) {
    positions[index] = Math.max(
      entries[index].desiredTop,
      positions[index - 1] + entries[index - 1].height + CARD_GAP
    );
  }

  const positionsById = {};
  entries.forEach(function (entry, index) {
    positionsById[entry.item.id] = Math.round(positions[index]);
  });

  return positionsById;
}
